'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var scrollSnoop = function scrollSnoop(element, state) {
  var bounding = element.getBoundingClientRect();
  var type = state || '';

  if (type == 'strict') {
    return bounding.top <= window.innerHeight && bounding.bottom >= 0 && bounding.left <= window.innerWidth && bounding.right >= 0 && getComputedStyle(element).display !== 'none';
  } else {
    return bounding.top <= window.innerHeight && bounding.bottom >= 0 && getComputedStyle(element).display !== 'none';
  }
};

exports.default = scrollSnoop;